"use client";

export { AnimatePresence } from "../../framer-motion/dist/es/components/AnimatePresence/index.mjs"